import globalDomains from '@/utils/global-domains';

export const DEFAULT_POSTER_THUMB_TMG = (isDarkMode) =>
  `${globalDomains.RES_AFREECATV}/images/svg/category_thumb_default${isDarkMode ? '_dark' : ''}.svg`;

export const SOOP_UI_IMG_TYPES = {
  thumbnail: 'thumbs',
  banner: 'banner',
  poster: 'poster',
};
